import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceSubs {
    lookupService = new APIServiceLookUp();

    async createSubscription(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}subscription/createSubscription`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllSubs(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}subscription/getAllSubs`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateSubscription(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}subscription/updateSubscription`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async renewSubscription(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}subscription/renewSubscription`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllTrns(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}transaction/getAllTrns`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getSubByFilter(body) {
        var serviceType = "POST";
        var url = `${API_URL}subscription/getSubByFilter`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async registerOutlet(body, orgid) {
        var serviceType = "CUST";
        var url = `${API_URL}auth/registerOutlet`;
        var apiService = this.lookupService.getAPIService(serviceType);
        var requestHeaders = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'x-org-id': orgid,
        };
        return await apiService.doCall(url, body, requestHeaders);
    }

}